/**
 * Dashboard chart card component
 */

import './ChartCard.css';

/**
 * Card displaying a simple bar chart
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @param {Array} props.data - Chart data [{label, value}]
 * @param {string} props.emptyMessage - Message when no data
 * @returns {React.ReactElement} Card element
 */
export default function ChartCard({
  title,
  data = [],
  emptyMessage = 'No data available'
}) {
  const maxValue = Math.max(...data.map(d => d.value), 1);

  return (
    <div className="chart-card">
      <h3 className="chart-card__title">{title}</h3>

      {data.length === 0 ? (
        <div className="chart-card__empty">{emptyMessage}</div>
      ) : (
        <div className="chart-card__bars">
          {data.map((item, index) => (
            <div key={index} className="chart-card__bar-row">
              <div className="chart-card__bar-label">{item.label}</div>
              <div className="chart-card__bar-container">
                <div
                  className="chart-card__bar"
                  style={{ width: `${(item.value / maxValue) * 100}%` }}
                />
                <span className="chart-card__bar-value">{item.value}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
